import restApi from './congressApiService'

const poisService = {}

poisService.getAll = () => {
  return restApi.get('/pois').then((response) => {
    return response.data
  })
}

poisService.getAllByCity = city => {
  return restApi.get('/pois')
    .then((response) => {
      return response.data.data
    })
    .then(pois => {
      const poisFilteredByCity = pois.filter(poi => {
        if (poi.metadata.googlePlace.formatted_address.includes(city + ', España')) {
          return true
        }
      })
      return poisFilteredByCity
    })
    .catch(err => {
      throw new Error(err)
    })
}

export default poisService
